export default {
  login: "login",
  user: "user/new",
  forgotPassword: "forgot-password",
  setPassword: "set-password",
  getUser: "user"
};
